import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign, CancelCampaignRequest } from '@aslanpay/portal-common-lib';

interface CancelCampaignMutation extends CancelCampaignRequest {
  campaignId: string;
}

const useCancelCampaign = (
  options: UseMutationOptions<Campaign, Error, CancelCampaignMutation>
) => {
  return useMutation<Campaign, Error, CancelCampaignMutation>(
    ({ campaignId, reason }) => campaignsService.cancelCampaign(campaignId, { reason }),
    options
  );
};

export default useCancelCampaign;
